var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VDialog",
    {
      attrs: {
        lazy: "",
        scrollable: "",
        contentClass: _vm.contentClass,
        maxWidth: _vm.maxWidth,
        noClickAnimation: _vm.noClickAnimation,
        persistent: _vm.persistent
      },
      model: {
        value: _vm.model,
        callback: function($$v) {
          _vm.model = $$v
        },
        expression: "model"
      }
    },
    [
      _c(
        "VCard",
        [
          _vm.$slots.title
            ? _c(
                "VToolbar",
                [
                  _c("VToolbarTitle", [_vm._t("title")], 2),
                  _vm._v(" "),
                  _c("VSpacer"),
                  _vm._v(" "),
                  _c(
                    "VBtn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.model = false
                        }
                      }
                    },
                    [_vm._v("\n        Close\n      ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "VCardText",
            [
              !_vm.$slots.title
                ? _c(
                    "button",
                    {
                      staticClass: "close-btn",
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.model = false
                        }
                      }
                    },
                    [_c("VIcon", [_vm._v("mdi-close")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default")
            ],
            2
          ),
          _vm._v(" "),
          _vm.$slots.actions
            ? _c("VCardActions", [_vm._t("actions")], 2)
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }